import { Observable } from 'rxjs'
import { Address } from '@spartacus/core'

export abstract class MbCheckoutBillingAddressesAdapter {

  abstract load(): Observable<Address[]>
}
